module.exports = __webpack_public_path__ + "static/media/6.0f4b194e.jpg";